import { isValidElement, useMemo } from 'react';

import { DrawerHeaderProps, UseDrawerHeaderArgs } from '../drawer.types';
import { DrawerHeader } from '../header/drawer-header';

export const useDrawerHeader = ({ header, mode, titleId }: UseDrawerHeaderArgs) => {
  const headerTitle =
    !header || isValidElement(header) ? undefined : (header as DrawerHeaderProps).title;

  const headerElement = useMemo(() => {
    if (!header) {
      return <DrawerHeader mode={mode} titleId={headerTitle ? titleId : undefined} />;
    }

    if (isValidElement(header)) return header;

    return (
      <DrawerHeader
        {...(header as DrawerHeaderProps)}
        mode={mode}
        titleId={headerTitle ? titleId : undefined}
      />
    );
  }, [header, headerTitle, mode, titleId]);

  return {
    headerTitle,
    headerElement,
  };
};
